import { Navigate,Outlet } from "react-router-dom"
import { useAuth } from "./AuthContext"
function ProtectedAdmin(){
    const {user}=useAuth()
    if(user?.type_compte==="Admin"){
        return <Outlet />
    }
}
export default ProtectedAdmin